import KOL1 from '../static/images/Block4/KOL1.jpg';
import KOL2 from '../static/images/Block4/KOL2.jpg';
import KOL3 from '../static/images/Block4/KOL3.jpg';
import KOL4 from '../static/images/Block4/KOL4.jpg';
import KOL5 from '../static/images/Block4/KOL5.jpg';
import KOL6 from '../static/images/Block4/KOL6.jpg';
import KOL7 from '../static/images/Block4/KOL7.jpg';
import KOL8 from '../static/images/Block4/KOL8.jpg';
import KOL9 from '../static/images/Block4/KOL9.jpg';
import KOL10 from '../static/images/Block4/KOL10.jpg';
import KOL11 from '../static/images/Block4/KOL11.jpg';
import KOL12 from '../static/images/Block4/KOL12.jpg';

export const cardRow1 = [{
  id: 11,
  image: KOL11,
  name: '那些電影教我們的事',
  title: null,
  context: '一直以為打球就是所有球員的夢想，但直到看了許多運動員的真實故事電影之後，才明白原來有些時候他們追求的，並不是那些表面的夢想，而是那夢想背後所乘載的希望：或許是為了完成家人的心願、或許是想要解決自己的經濟困境⋯⋯而在《倆好球》中，兩個小球員是為了日後能夠不再與家人分開⋯⋯『當你想家人的時候，可以來抱我。』從他們單純良善的話語中，我們深切領悟：愛從來不僅限於血緣之親，只要願意去理解與關懷，或許就會發現我們也在經歷相同的苦痛、分享著同樣的夢想。',
}, {
  id: 12,
  image: KOL12,
  name: '廣告裁判',
  title: null,
  context: '你有夢想嗎？如果有的話，你願意為它付出什麼代價？兩個宜蘭男孩，背負著各自的分離、思念與夢想，他們在球場相遇，也在這裡齊心努力。球場上的汗水、生活中的眼淚。都在每次的揮棒、投捕與相擁之間，化作支持彼此的深刻羈絆。那個小小的願望：「想打一支全壘打，或安打」，或許不只是想追求自己的好表現，而是想繼續和彼此在球場肩並肩，擊出夢想的勝利打點。',
}, {
  id: 2,
  image: KOL3,
  name: 'Apple Lin',
  title: 'Home Run Taiwan 好朋友',
  context: '或許他們不是自願進球隊的，但他們團結的大愛與付出值得學習。「逃隊沒關係，只要你下次想家人的時候可以來抱我」這句話真的貼心的讓人想哭。我們時常用自己被教育的框架去綁住自己和別人，但其實沒有人不犯錯，其實停下來聆聽、多一點付出，對方絕對能感受到的。',
}, {
  id: 3,
  image: KOL4,
  name: '黃星倫',
  title: 'Home Run Taiwan 好朋友',
  context: '覺得無限感動，尤其教練中段講的一句話「就是要讓自己不斷的去突破自己的瓶頸，用理念帶著自己往前走」身為大人看到這句話也會去思考自己當下的困境可以如何突破，可能是態度，可能是工作⋯⋯。回想起以前的棒球校隊生活，一模一樣的訓練方式，非常辛苦。看著三星國小小球員卻也更加能體會，全天候的照顧自己，看出來的是背後的苦，隔代教養的社會問題，「棒球」變成了能溫暖他們的共同出口！',
}, {
  id: 4,
  image: KOL5,
  name: '李昱霖',
  title: 'Home Run Taiwan 好朋友',
  context: '好感人嗚嗚邊看邊流淚，逆境中成長的孩子真的需要更多堅強的意志力以及過人的決心，打棒球的孩子不會變壞，希望未來都能在職棒的球場上看到他們，也希望自己以後有能力能去幫助更多愛打棒球的孩子們。',
}, {
  id: 6,
  image: KOL7,
  name: 'Jesse Chen',
  title: 'Home Run Taiwan 好朋友',
  context: '相信不只在宜蘭，也不僅僅棒球（運動），在很多角落都有著默默地為下一代更好而付出的人，也有默默地為迎向更美好未來而努力的孩子（人）！感恩有人願意為他們發聲，也期望能有更多企業願意關注台灣的每一個角落，讓珍貴的資源實實在在地被用在需求的人身上！',
}];

export const cardRow2 = [{
  id: 0,
  image: KOL1,
  name: '李榮峰',
  title: 'EMT Tough 生命急難救助團隊負責人',
  context: '我是家中的長子，除了一個妹妹之外，我很想要有一個可以一起玩、一起打架、一起共患難同享福的哥哥或弟弟。 當許子謙對逃隊的曾煒晟說：「想家人的時候，可以去抱他⋯⋯」我傻在螢幕的這一端好久，眼淚不想忍耐的直流。許子謙好溫暖！！ 這一顆熱血的種子，長大之後會是怎樣的一棵大樹啊⋯⋯這個世界，雖然有許多事總是倒著走！但期許我們的孩子，都可以變成更好更正直的大人，朝著自己的夢想前進。',
}, {
  id: 1,
  image: KOL2,
  name: '許廷瑞',
  title: '金屬雕塑家、飛行約翰主唱',
  context: '小時候經歷過籃球隊田徑隊拳擊隊。一直覺得競技運動最迷人的除了爭奪冠軍渴望，其他就是團隊的生活。一起往著同樣的目標前進，一起生活吶喊、一起失落享受，就像沒有沒有血緣的”家人”。看到小球員的訓練，總是回想到夢想這麼小，如果在追逐的路上有一起支持的朋友，那再多艱難的路都能一起爬過去的。還記得當年和你一起奮鬥的”家人”嗎？找個理由一起進球場看球吧！',
}, {
  id: 5,
  image: KOL6,
  name: '王志忠',
  title: 'Home Run Taiwan 好朋友',
  context: '我是一位種植培育棒球小幼苗的小農。讓學習棒球的孩子路能走的更寬闊，正面影響更多人，這是我的使命。棒球不是一條唯一的道路，但棒球對一些孩子卻是一條有未來也能好好獨立照顧自己與家人的道路。棒球囡仔加油！透過棒球的學習能影響更多人，透過棒球讓更多孩子有好的出入，正面影響更多家庭與社會！',
}, {
  id: 7,
  image: KOL8,
  name: '許梨子',
  title: 'Home Run Taiwan 好朋友',
  context: '小身軀充滿著巨大的毅力跟對家人及隊友的愛。每一顆打擊出去的球都是一道美麗到讓人感動無比的弧線。謝謝你們教會我們大人什麼叫勇敢與愛。',
}, {
  id: 8,
  image: KOL9,
  name: 'Nini Hsiao',
  title: 'Home Run Taiwan 好朋友',
  context: '凌晨看這影片是要讓我感動流淚到睡不著覺嗎？我是位都市裡的老師，看了影片才知道原來偏鄉的資源遠比我想像的還困乏，但這群孩子的努力更顯得他們的天真無邪，小朋友們，加油！！許子謙，叔叔會記得你這名字的，未來的 CT、中職甚至 MLB，一定能看到這名字，就算以後你不打球了，從小就懂得謙卑與關懷，你已經成功一半了！',
}];
